export default "assets/images/section-mask-945536ea.svg";